import styled from 'styled-components'

export const MenuButton = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 12px;
  color: ${(props) => props.theme.colours.neutrals.N040};
  background-color: ${(props) => props.theme.colours.surfaces.S090};

  &:hover {
    cursor: pointer;
  }
`
